export class AuthenticationPermissionModel {
    hasEnterpriseConnection;
}
//# sourceMappingURL=authentication-permission.js.map